/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Services_Streamer_BodyInputs */

const ja_playdata_home_services_streamer_body = /** @type {(inputs: Playdata_Home_Services_Streamer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期間やゲーム、キーワードなどを検索・フィルタリングすることで、現在注目を浴びているストリーマーを見つけられるツールもご用意。今後のトレンドを発見するための強力なアシストとなります。`)
};

const en_playdata_home_services_streamer_body = /** @type {(inputs: Playdata_Home_Services_Streamer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and filter by period, game or keyword to find the streamers drawing attention right now — a strong assist for spotting the next trend.`)
};

/**
* | output |
* | --- |
* | "Search and filter by period, game or keyword to find the streamers drawing attention right now — a strong assist for spotting the next trend." |
*
* @param {Playdata_Home_Services_Streamer_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_services_streamer_body = /** @type {((inputs?: Playdata_Home_Services_Streamer_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Services_Streamer_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_services_streamer_body(inputs)
	return en_playdata_home_services_streamer_body(inputs)
});